module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.step.options), function(option, index) {
    return _c('div', {
      staticClass: "klickbox-step-options"
    }, [_c('label', [_c('input', {
      attrs: {
        "disabled": "",
        "type": [_vm.step.multiple_answers ? 'checkbox' : 'radio'],
        "name": _vm.step.id
      },
      domProps: {
        "value": option.label
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "klickbox-step-input-edit",
      class: {
        'klickbox-step-input-other': option.other
      },
      attrs: {
        "type": "text",
        "placeholder": _vm.$t('edit.canvas.multiple_choice_placeholder')
      },
      domProps: {
        "value": option.label
      },
      on: {
        "change": function($event) {
          return _vm.optionUpdateText({
            event: $event,
            id: option.id
          })
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "klickbox-step-bar"
    })]), _vm._v(" "), (!option.other && _vm.step.kind !== 'yes-no') ? _c('div', {
      staticClass: "klickbox-step-remove-option",
      on: {
        "click": function($event) {
          return _vm.optionRemove({
            id: option.id,
            index: index
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.step.kind === 'multiple-choice') ? _c('div', {
    staticClass: "klickbox-step-options"
  }, [_c('label', {
    staticClass: "klickbox-step-add-option",
    on: {
      "click": function($event) {
        return _vm.optionAdd({
          other: false
        })
      }
    }
  }, [_c('input', {
    attrs: {
      "type": [_vm.step.multiple_answers ? 'checkbox' : 'radio'],
      "disabled": ""
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('edit.canvas.add_option')) + "\n      ")])]) : _vm._e()], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-98fc327c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/kind/MultipleChoice.vue
 ** module id = 887
 ** module chunks = 1
 **/